import React from "react";
import { FormikErrors, FormikTouched } from "formik";
import DatePicker from "react-date-picker";

interface BYDatePickerProps {
  title?: string;
  name?: string;
  disabled?: boolean;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  onChange?: (arg0: string | Date) => void;
  value?: string | Date;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

const BYDatePicker = (props: BYDatePickerProps) => {
  const {
    title,
    disabled,
    touched,
    error,
    onChange,
    value,
    required,
    name,
    minDate,
    maxDate,
  } = props;

  const displayError = touched && error;

  let dateValue = value;
  if (typeof dateValue === "string") {
    dateValue = new Date(dateValue);
  }

  return (
    <>
      {title && <label className="form-label">{title}</label>}
      <div>
        <DatePicker
          format="dd/MM/yyyy"
          className="form-control"
          onChange={onChange}
          value={dateValue}
          required={required}
          disabled={disabled}
          name={name}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>
      {displayError && (
        <div className="text-danger font-weight-bold">{error}</div>
      )}
    </>
  );
};

export default BYDatePicker;
